/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Edit_While_StreamingInputs */



/**
* | output |
* | --- |
* | "Wait for the current response to finish." |
*
* @param {Chat_Edit_While_StreamingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_edit_while_streaming = /** @type {((inputs?: Chat_Edit_While_StreamingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Edit_While_StreamingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warten Sie, bis die aktuelle Antwort fertig ist.")
	return /** @type {LocalizedString} */ ("Wait for the current response to finish.")
});